import React from 'react';
import styled from 'styled-components';

export const READER_IFRAME_ID = 'DocPageReaderIframe';

const IFrame = styled.iframe`
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    border: none;
`;

type Props = {
    setReaderFrame: (refElement: HTMLIFrameElement) => void;
    readerUrl: string;
    title: string;
};

const ReaderIframe: React.FC<Props> = ({ setReaderFrame, readerUrl, title }: Props) => (
    <IFrame
        allowFullScreen
        id={READER_IFRAME_ID}
        ref={setReaderFrame}
        src={readerUrl}
        tabIndex={0}
        title={title}
    />
);
export default ReaderIframe;
